import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=3c6ac99e&scoped=true&"
import script from "./Marketing.vue?vue&type=script&lang=js&"
export * from "./Marketing.vue?vue&type=script&lang=js&"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=3c6ac99e&prod&lang=scss&scoped=true&"
import style1 from "./Marketing.vue?vue&type=style&index=1&id=3c6ac99e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ac99e",
  null
  
)

export default component.exports